import React from "react";
import { Link } from "react-router-dom";
import horizont from "../../images/portfolio/horizontJobs.WebP";
import th_upizol from "../../images/portfolio/th-upizol.WebP";
import hanchakweb from "../../images/portfolio/hanchakweb.WebP";
import strahl from "../../images/portfolio/strahl.WebP";
import speedApp from "../../images/portfolio/TypingSpeedApp.WebP";
import snakeGame from "../../images/portfolio/SnakeGame.WebP";
import ogImage from "../../images/portfolio/ogImage.WebP";
import stopWatch from "../../images/portfolio/StopWatch.WebP";
import catEnergy from "../../images/portfolio/CatEnergy.WebP";

import "./summary.css";
import { useTranslation } from "react-i18next";

const Summary = () => {
  const { t } = useTranslation();
  return (
    <div className="container summary row">
      <div className="container itemSummary col">
        <a
          href="https://body-energy.web.app/"
          rel="noreferrer noopener"
          target="_blank"
        >
          <img alt="Cat Energy" src={catEnergy} />
          <p>{t("Summary.obj8")}</p>
        </a>
      </div>
      <div className="container itemSummary col">
        <a
          href="https://github.com/AlexHanchak/snakeByPygame"
          rel="noreferrer noopener"
          target="_blank"
        >
          <img alt="Snake Game =)" src={snakeGame} />
          <p>{t("Summary.obj7")}</p>
        </a>
      </div>
      <div className="container itemSummary col">
        <a
          href="https://github.com/AlexHanchak/TypingSpeedApplication"
          rel="noreferrer noopener"
          target="_blank"
        >
          <img alt="Typing Speed App" src={speedApp} />
          <p>{t("Summary.obj6")}</p>
        </a>
      </div>
      <div className="container itemSummary col">
        <a
          href="https://github.com/AlexHanchak/stopWatch"
          rel="noreferrer noopener"
          target="_blank"
        >
          <img alt="Stop Watch" src={stopWatch} />
          <p>{t("Summary.obj5")}</p>
        </a>
      </div>
      <div className="container itemSummary col">
        <a
          href="https://strahl-49561.firebaseapp.com/"
          rel="noreferrer noopener"
          target="_blank"
        >
          <img alt="Strahl" src={strahl} />
          <p>{t("Summary.obj4")}</p>
        </a>
      </div>
      <div className="container itemSummary col">
        <Link to={"/"}>
          <img alt="hanchakweb" src={hanchakweb} />
          <p>{t("Summary.obj3")}</p>
        </Link>
      </div>
      <div className="container itemSummary col">
        <a
          href="https://horizont-jobs-jl.firebaseapp.com/"
          rel="noreferrer noopener"
          target="_blank"
        >
          <img alt="horizont" src={horizont} />
          <p>{t("Summary.obj2")}</p>
        </a>
      </div>
      <div className="container itemSummary col">
        <a
          href="https://th-upizol.000webhostapp.com/"
          rel="noreferrer noopener"
          target="_blank"
        >
          <img alt="th-upizol" src={th_upizol} />
          <p>{t("Summary.obj1")}</p>
        </a>
      </div>
      <img alt='img' hidden src={ogImage}/>
    </div>
  );
};

export default Summary;
